import { zapsToBePausedQuery } from './useZapsToBePaused';

export const zapsToBePausedMocks = [
  {
    request: {
      query: zapsToBePausedQuery,
      variables: {
        accountId: 1,
        planId: '1',
      },
    },
    result: {
      data: {
        zapsToBePaused: [
          {
            __typename: 'ZapV2',
            id: '247',
          },
          {
            __typename: 'ZapV2',
            id: '242',
          },
        ],
      },
    },
  },
];
